import { useEffect, useState, type FormEvent } from "react";
import { api } from "../api";
import type { AccessRow, Role } from "../types";

export default function AdminPanel() {
  const [form, setForm] = useState({email: "", name: "", role: "manager" as Role, active: true});
  const [rows, setRows] = useState<AccessRow[]>([]);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function load() {
    setRows(await api.listAccess());
  }

  useEffect(() => { void load(); }, []);

  async function save(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    setError("");

    try {
      await api.saveAccess(form);
      setMessage(`${form.email} was saved.`);
      setForm({email: "", name: "", role: "manager", active: true});
      await load();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Access could not be saved.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="stack">
      <section className="panel">
        <div className="panel-heading"><div><span className="eyebrow">Google-account authorization</span><h2>User Administration</h2></div></div>
        <form className="admin-form" onSubmit={save}>
          <label className="wide">Gmail Address<input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required /></label>
          <label>Name<input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required /></label>
          <label>Role<select value={form.role} onChange={(e) => setForm({...form, role: e.target.value as Role})}><option value="manager">Manager</option><option value="view_only">View Only</option><option value="admin">Admin</option><option value="developer">Developer</option></select></label>
          <label className="checkbox"><input type="checkbox" checked={form.active} onChange={(e) => setForm({...form, active: e.target.checked})} /> Active</label>
          <button className="primary" disabled={busy}>Save Access</button>
        </form>

        <div className="table-wrap compact-table">
          <table>
            <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Signed In</th></tr></thead>
            <tbody>{rows.map((row) => <tr key={row.email}><td>{row.name}</td><td>{row.email}</td><td>{row.role}</td><td>{row.active ? "Active" : "Inactive"}</td><td>{row.signedIn ? "Yes" : "Not yet"}</td></tr>)}</tbody>
          </table>
        </div>
      </section>
      {message && <p className="success">{message}</p>}
      {error && <p className="error">{error}</p>}
    </div>
  );
}
